import type { History } from 'quartz-routing/react-router';
import anonymousStorage from 'usage-tracker-core/containers/anonymousStorage';
import tempStorage from 'usage-tracker-core/containers/tempStorage';
import { hamplitudeKey } from 'usage-tracker-core/storageKeys';

// This attempts to get an UUID from the URL, if it doesn't exist it will simply return undefined
export const getUuidFromUrl = (location: History['location']) => {
  const searchParams = new URLSearchParams(location.search);

  return searchParams.get('uuid') || undefined;
};

export const resetAmplitudeStorageIfNeeded = (deviceId: string) => {
  // If we have the same deviceId stored on the localStorage we should reset that
  // since we shouldn't identify the same user with different devices
  if (tempStorage.getItem(hamplitudeKey)?.includes(deviceId)) {
    tempStorage.removeItem(hamplitudeKey);
  }

  // When switching from anonymous to non-anonymous we want to clear the
  // anonymous tracker sessionStorage
  anonymousStorage.removeItem(hamplitudeKey);
};
